import React from 'react'
import { Col, Row } from 'antd'
import LmsSettingsCard from './LmsSettingsCard'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'

const LmsSection = () => {
    useDocumentTitle('LMS')

    return (
        <Row gutter={[24, 24]}>
            <Col span={8}>
                <LmsSettingsCard />
            </Col>
        </Row>
    )
}

export default LmsSection
